import { render, staticRenderFns } from "./MigrationPollInfoDialog.vue?vue&type=template&id=929a2cd4"
import script from "./MigrationPollInfoDialog.vue?vue&type=script&lang=js"
export * from "./MigrationPollInfoDialog.vue?vue&type=script&lang=js"
import style0 from "./MigrationPollInfoDialog.vue?vue&type=style&index=0&id=929a2cd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports